module.exports = "//static.hsappstatic.net/ecosystem-marketplace-solutions-base/static-1.13216/img/city-pages-social-image.svg"